<template>
  <div class="solutions-list">
    <table>
      <thead v-if="!IsMobile">
        <tr>
          <slot name="table-headers"></slot>
        </tr>
      </thead>
      <tbody v-if="IsMobile && viewLoader && items && items.length">
        <slot name="mobile-row" v-for="(item, keyItem) in items" :item="item" :key="keyItem"></slot>
      </tbody>
      <tbody v-else-if="!IsMobile && viewLoader && items && items.length">
        <slot name="desktop-row" v-for="(item, keyItem) in items" :item="item" :key="keyItem" :class="{ odd: keyItem % 2 }"></slot>
      </tbody>
      <tbody v-else-if="viewLoader">
        <tr>
          <td :colspan="colspan" style="text-align: center">
            <span>{{ noDataMessage }}</span>
          </td>
        </tr>
      </tbody>
    </table>
    <div>
      <br /><br />
      <StatusAlert v-if="viewError" status="error" role="alert">
        <template #body>
          <p v-html="$t('tickets.error')"></p>
        </template>
      </StatusAlert>
    </div>
    <paginator
      v-if="totalPage > 1"
      :total-page="totalPage"
      :current-page="currentPage"
      @change-page="changePage"
      @prev-page="prevPage"
      @next-page="nextPage"
    ></paginator>
  </div>
</template>

<script>
import StatusAlert from "@/components/Primitives/Alerts/StatusAlert.vue";
import Paginator from "@/components/Paginator.vue";

export default {
  name: "SolutionsList",
  components: {
    StatusAlert,
    Paginator,
  },
  props: {
    list: {
      type: Array,
      required: true,
    },
    viewLoader: {
      type: Boolean,
      default: true,
    },
    viewError: {
      type: Boolean,
      default: false,
    },
    noDataMessage: {
      type: String,
      required: true,
    },
    colspan: {
      type: Number,
      default: 7,
    },
    pageSize: {
      type: Number,
      default: 10,
    },
  },
  data() {
    return {
      currentPage: 1,
      IsMobile: this.$IsMobile(),
    };
  },
  methods: {
    changePage(page) {
      this.currentPage = page;
    },
    nextPage() {
      if (this.currentPage == this.totalPage) {
        return;
      }
      this.currentPage = parseInt(this.currentPage) + 1;
    },
    prevPage() {
      if (this.currentPage == 1) {
        return;
      }
      this.currentPage = parseInt(this.currentPage) - 1;
    },
  },
  computed: {
    totalPage() {
      return Math.ceil(this.list.length / this.pageSize) > 1
        ? Math.ceil(this.list.length / this.pageSize)
        : 1;
    },
    items() {
      return this.list.slice(
        (this.currentPage - 1) * this.pageSize,
        this.pageSize * this.currentPage
      );
    },
  },
};
</script>
